import { useState } from "react"
import { DrawerForm } from "../../../../components/drawers/DrawerForm"
import { getUser, useHub, useJobSources, useTechsAll } from "../../../../core/Global"
import RadioButtonList from "../../../../components/form/RadioButtonList"
import DropDown from "../../../../components/form/DropDown"
import BalanceSheetModel from "../models/BalanceSheetModel"
import TextBox from "../../../../components/form/TextBox"
import DatePicker from "../../../../components/form/DatePicker"
import TextArea from "../../../../components/form/TextArea"
import ToggleSwitch from "../../../../components/form/ToggleSwitch"
import { API_ROUTES } from "../../../../core/Constants"
import { toastSuccess } from "../../../../components/base/Toast"
import BalanceTransaction from "../models/BalanceTransaction "

interface IProps {
    item?: BalanceTransaction
    defaultParty?: string
    onClose: () => void
    onSave?: () => void
}

export default function TransactionForm(props: IProps) {

    const hub = useHub()
    const user = getUser()
    const jobSources = useJobSources()
    const techs = useTechsAll()

    const [customDate, customDateSet] = useState<boolean>(props.item?.customDate ?? false)

    const [SelectedParty, SelectedPartySet] = useState<string>(props.item?.party?.toString() ?? props.defaultParty ?? "1")



    return (
        <DrawerForm id="drawer-form-transaction" permanent
            title={props.item ? "Edit Transaction" : "Create Transaction"}
            buttonText={props.item ? "Update Transaction" : "Create Transaction"}
            onClose={props.onClose}
            onSubmit={(body, callback) => {

                hub.Post("/reports/balance/savetransaction", {
                    ...body,
                    id: props.item?.id
                }, res => {

                    if (res.success) {
                        toastSuccess("Transaction has been saved successfully!")
                        props.onSave?.()
                    }
                    callback!(res)

                })

            }}>

            {
                SelectedParty == "2" ?
                    <RadioButtonList key="rd-buttons-source"
                        name="type" value="2"
                        source={[
                            {
                                id: "2",
                                name: "Pay"
                            }
                        ]} />
                    :
                    <RadioButtonList key="rd-buttons-techs"
                        name="type" value={props.item?.type ?? "1"}
                        source={[
                            {
                                id: "1",
                                name: "Receive"
                            },
                            {
                                id: "2",
                                name: "Pay"
                            }
                        ]} />
            }




            <DropDown id="drp-transaction-party" name="party" forceSelectValue={SelectedParty}
                block labelUp label="Transaction Party" deselect={false}
                onSelect={e => SelectedPartySet(e ?? "1")}
                source={[
                    {
                        id: "1",
                        name: "Technician"
                    },
                    {
                        id: "2",
                        name: "Source"
                    }
                ]} />


            {
                SelectedParty == "2" ?
                    <DropDown key="drp-sources-select" id="drp-sources-select" name="sourceId"
                        block labelUp label="Source" dataText="title" dataValue="value"
                        apiSource={API_ROUTES.TagifyJobSources} forceSelectValue={props.item?.sourceId} />
                    :
                    <DropDown key="drp-techs-select" id="drp-techs-select" name="techId"
                        block labelUp label="Technician"
                        source={techs} dataText="fullName" dataValue="id"
                        forceSelectValue={props.item?.techId} />
            }



            <TextBox id="txt-transaction-amount" name="amount"
                block labelUp label="Amount" value={(props.item?.amount)}
                money icon="dollar-sign" />

            <TextArea id="txt-trasnaction-description" name="description" value={props.item?.description}
                block labelUp label="Description" rows={5} marginBottom={5} />

            <ToggleSwitch id="toggle-transaction-custom-date" checked={customDate}
                raw small onChange={e => customDateSet(e)} className="mb-5"
                label="Custom Transaction Date" />

            {
                customDate &&
                <>
                    <DatePicker id="dt-transaction-date" name="date"
                        timePicker drops="up" block labelUp date={props.item?.transactionDate}
                        label={`Transaction Date`} icon="calendar" />

                    {/* <DropDown id="drp-redurectrules-timezones" name="timezone" label="Timezone" labelUp block deselect={false}
                        apiSource={API_ROUTES.Users + "timezones"} forceSelectValue={props.item?.timezone ?? user?.timeZoneId} /> */}
                </>
            }

            <div className="mb-10"></div>

        </DrawerForm>
    )
}